import { render, staticRenderFns } from "./bsweepshc.vue?vue&type=template&id=5a054434&scoped=true&"
import script from "./bsweepshc.vue?vue&type=script&lang=js&"
export * from "./bsweepshc.vue?vue&type=script&lang=js&"
import style0 from "./bsweepshc.vue?vue&type=style&index=0&id=5a054434&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a054434",
  null
  
)

export default component.exports